export function getSearchResultsBasePath(pathname: string) {
  const isNewsPage = pathname.split('/').includes('news');

  return isNewsPage ? '/news/' : '/release-dates/';
}
